import queryString from 'query-string';
import config from '../config';

export type RequestParams = {
  [key: string]: string | number | boolean;
};

export const sendRequest = <T>(
  requestParams: RequestParams,
  options: RequestInit = {},
): Promise<T> => {
  return fetch(config.serverUrl + queryString.stringify(requestParams), options)
    .then((res) => res.json())
    .then((res) => {
      if (res.errorCode) {
        throw new Error(res.errorDescription, {
          cause: {
            ...res,
          },
        });
      }
      return res;
    });
};
